<boi-contextual-help-container
  [ngClass]="{ 'has-errors': hasError }"
  [contextualHelpName]="contextualHelpName !== undefined ? contextualHelpName : labelName"
>
  <boi-validation-error (errorChange)="hasError = $event" [propertyNames]="propertyNames"></boi-validation-error>
  <kendo-textbox-container class="form-element app">
    <div class="form-label" [boiRequiredFormField]="labelName">
      <label [for]="controlId ? controlId : labelName" [innerHtml]="labelName | localizeLabel"></label>
    </div>
    <div class="form-input-container">
      <textarea
        kendoTextArea
        [id]="controlId ? controlId : labelName"
        [(ngModel)]="value"
        [disabled]="isFieldDisabled"
        [readonly]="isReadonly"
        (ngModelChange)="valueChange.emit(value)"
        [maxlength]="fieldMaxLength"
      >
      </textarea>
    </div>
    <boi-tooltip [tooltipName]="tooltipName ? tooltipName : labelName"></boi-tooltip>
  </kendo-textbox-container>
</boi-contextual-help-container>
